import _ from "lodash";

import { apiEncrypt } from "./keyEncryption";
import { isPremiumUser } from "./utils";

export const formatDashboardShiftJobs = (job_list, currentPage) => {
  let jobListArr = Object.keys(job_list);
  let newObj = {};
  if (jobListArr && jobListArr.length > 0) {
    let rowId = 1;
    if (currentPage > 1) {
      rowId = (currentPage - 1) * 16 + 1;
    }
    jobListArr.forEach((date) => {
      let shiftArr = job_list[date];
      let arr = [];
      shiftArr.forEach((shift) => {
        const {
          candidate_id,
          contract_date,
          contract_vacancy_id,
          contract_ref_no,
          contract_client_id,
          contract_parent_id,
          contract_start_time,
          contract_end_time,
          break_time,
          admin_time,
          contract_no_of_visit,
          total_requirements,
          session_type_id,
          role_name,
          candidate_name,
          profile_percent,
          candidate_total_worked,
          candidate_applicant_id,
          licence_no,
          profile_image,
          main_contract_refNo,
          main_contract_created_date,
          main_contract_start_date,
          main_contract_end_date,
          contract_status,
          contractDuration,
          candidate_email,
          mobile_phone_number,
          is_past_booking,
        } = shift;
        let _obj = {
          ...shift,
          row_id: rowId,
          route_id: candidate_id ? apiEncrypt(candidate_id) : null,
          candidate_id,
          route_contract_id: apiEncrypt(contract_parent_id),
          contract_date,
          contract_vacancy_id,
          contract_ref_no,
          contract_client_id,
          contract_parent_id,
          contract_start_time,
          contract_end_time,
          break_time,
          admin_time,
          contract_no_of_visit,
          total_requirements,
          session_type_id,
          role_name,
          candidate_name,
          profile_percent: profile_percent ? profile_percent : 0,
          candidate_total_worked,
          candidate_applicant_id,
          licence_no,
          profile_image,
          main_contract_ref_no: main_contract_refNo,
          main_contract_created_date,
          main_contract_start_date,
          main_contract_end_date,
          contract_status,
          contract_duration: contractDuration,
          candidate_email: isPremiumUser() ? candidate_email : null,
          mobile_phone_number: isPremiumUser() ? mobile_phone_number : null,
          showpopup: false,
          is_past_booking: is_past_booking,
        };
        arr.push(_obj);
        rowId++;
      });
      newObj[date] = arr;
    });
  }
  return newObj;
};

// Contract Details - Shifts Tab
export const formatContractShifts = (shifts) => {
  let arr = [];

  shifts.forEach((shift) => {
    let obj = {
      shift_id: shift.shift_id,
      contract_date: shift.contract_date,
      start_time: shift.start_time,
      end_time: shift.end_time,
      break_time: shift.break_time,
      admin_time: shift.admin_time,
      no_of_visit: shift.no_of_visit,
      shift_rate: shift.shift_rate,
      unit: shift.unit,
      timesheet_status: shift.timesheet_status,
      client_pay_arr: shift.client_pay_arr,
      cover_request_awarded_reward: shift?.cover_request_awarded_reward || 0,
      visit_charge: shift?.visit_charge,
    };
    let timesheetStatus = shift.timesheet_status;
    if (timesheetStatus == "Authorized" || timesheetStatus == "Authorised") {
      obj.authorised_by_name = shift.authorised_by_name;
      obj.authorised_at = shift.authorised_at;
      obj.authorised_from = shift.authorised_from;
    } else if (timesheetStatus == "Rejected") {
      obj.rejected_by_name = shift.rejected_by_name;
      obj.rejected_at = shift.rejected_at;
      obj.rejected_from = shift.rejected_from;
    } else if (timesheetStatus == "Terminated") {
      obj.terminated_by_name = shift.terminated_by_name;
      obj.terminated_at = shift.terminated_at;
      obj.terminated_from = shift.terminated_from;
    }
    arr.push(obj);
  });
  return arr;
};

export const formatDashboardUpcomingModal = (shifts) => {
  let jobs = [];
  shifts.forEach((value) => {
    let obj = {
      is_ongoing: value.is_ongoing,
      contract_id: value.contract_id,
      route_id: apiEncrypt(value.candidate_id),
      candidate_id: value.candidate_id,
      route_contract_id: apiEncrypt(value.contract_parent_id),
      contract_client_id: value.contract_client_id,
      contract_vacancy_id: value.contract_vacancy_id,
      contract_date: value.contract_date,
      candidate_name: value.candidate_name,
      role_name: value.role_name,
      contract_start_time: value.contract_start_time,
      contract_end_time: value.contract_end_time,
      contract_ref_no: value.contract_refNo,
      contract_parent_id: value.contract_parent_id,
      contract_duration: value.contractDuration,
      profile_image: value.profile_image,
      licence_no: value.licence_no,
      profile_percent: value.profile_percent,
      break_time: value.break_time,
      candidate_email: isPremiumUser() ? value.candidate_email : null,
      mobile_phone_number: isPremiumUser() ? value.mobile_phone_number : null,
      running_late_status: isPremiumUser() ? value.running_late_status : false,
      running_late_reason: isPremiumUser() ? value.running_late_reason : null,
      is_time_started: value.is_time_started,
      logged_in_time: value.logged_in_time,
    };
    jobs.push(obj);
  });
  return jobs;
};

export const formatContractTerminatedShifts = (shifts) => {
  let arr = [];
  shifts.forEach((shift) => {
    let obj = {
      shift_id: shift.shift_id,
      contract_date: shift.contract_date,
      start_time: shift.start_time,
      end_time: shift.end_time,
      break_time: shift.break_time,
      admin_time: shift.admin_time,
      no_of_visit: shift.no_of_visit,
      shift_rate: shift.shift_rate,
      unit: shift.unit ? parseFloat(shift.unit) : 0,
      timesheet_status: shift.timesheet_status,
      client_pay_arr: shift.client_pay_arr,
      terminated_reason: shift.terminated_reason,
      terminated_date: shift.terminated_date,
      terminated_by: shift.terminated_by,
    };
    arr.push(obj);
  });
  return arr;
};

export const formatContractApplicantLists = (applicants) => {
  // console.log("is_past_booking", applicants)
  let arr = [];
  applicants.forEach((applicant) => {
    let obj = {
      candidate_id: applicant.candidate_id,
      route_id: applicant.candidate_id
        ? apiEncrypt(applicant.candidate_id)
        : null,
      route_contract_id: apiEncrypt(applicant.contract_id),
      contract_id: applicant.contract_id,
      contract_start_date: applicant.contract_start_date,
      contract_end_date: applicant.contract_end_date,
      contract_start_time: applicant.contract_start_time,
      contract_end_time: applicant.contract_end_time,
      applicant_id: applicant.applicant_id,
      candidate_name: applicant.candidate_name,
      role_name: applicant.role_name,
      mobile_phone_number: applicant.mobile_phone_number,
      candidate_email: applicant.candidate_email,
      profile_image: applicant.profile_image,
      profile_percent: applicant.profile_percent
        ? applicant.profile_percent
        : 0,
      license_number: applicant.license_number,
      total_days_of_contract: applicant.total_days_of_contract,
      contract_ref_no: applicant.contract_ref_no,
      is_day_rate: applicant.is_day_rate,
      contract_status: applicant.contract_status,
      apply_date: applicant.apply_date,
      is_canceled: applicant.is_canceled,
      miles: applicant.miles,
      candidate_sortlisted: parseInt(applicant.candidate_sortlisted),
      candidate_unsuitable: parseInt(applicant.candidate_unsuitable),
      rate: applicant.rate,
      is_negotiate: applicant.is_negotiate,
      isExpanded: false,
      has_various_times: parseInt(applicant.has_various_times),
      is_bank_contract: parseInt(applicant.is_bank_contract),
      is_bank_candidate: parseInt(applicant.is_bank_candidate),
      is_for_appLocum_candidates: parseInt(
        applicant.is_for_appLocum_candidates,
      ),
      bank_contract_publish_date: applicant.bank_contract_publish_date,
      contract_created_at: applicant.contract_created_at,
      is_past_booking: applicant?.is_past_booking,
      is_auto_booked_on_apply: parseInt(applicant.is_auto_booked_on_apply),
      is_substitute_contract: applicant?.is_substitute_contract,
      cover_request_awarded_reward:
        parseFloat(applicant?.cover_request_awarded_reward) || 0,
      cover_request_awarded_penalty:
        parseFloat(applicant?.cover_request_awarded_penalty) || 0,
      proposed_candidate_name: applicant?.proposed_candidate_name,
      proposed_contract_id: applicant?.proposed_contract_id,
      proposed_contract_ref: applicant?.proposed_contract_ref,
    };
    arr.push(obj);
  });
  return arr;
};

export const formatInvitedCandidates = (candidates) => {
  let arr = [];
  candidates.forEach((candidate) => {
    let obj = {
      candidate_invitation_id: candidate.candidate_invitation_id,
      candidate_name: candidate.candidate_name,
      candidate_id: candidate.candidate_id,
      route_id:
        candidate.candidate_id != "-"
          ? apiEncrypt(candidate.candidate_id)
          : "-",
      candidate_ref_no: candidate.candidate_ref_no,
      profile_image: candidate.profile_image,
      date_invited: candidate.date_invited,
      is_registered: parseInt(candidate.is_registered),
      profile_percent: candidate.profile_percent,
      candidate_role_type: candidate.candidate_role_type,
      license_number: candidate.license_number,
      date_registered: candidate.date_registered,
      role_name: candidate.candidate_type_name,
      candidate_address: candidate.candidate_address,
      candidate_sortlisted: parseInt(candidate.candidate_sortlisted),
      candidate_unsuitable: parseInt(candidate.candidate_unsuitable),
      candidate_total_worked: parseInt(candidate.candidate_total_worked),
      miles: parseFloat(candidate.miles),
      is_send: parseInt(candidate.is_send),
      actioned_by: candidate.actioned_by,
      actioned_at: candidate.actioned_at,
      candidate_email: isPremiumUser() ? candidate.candidate_email : null,
      mobile_phone_number: isPremiumUser()
        ? candidate.mobile_phone_number
        : null,
      is_override_compliance_expiration_period_set:
        candidate?.is_override_compliance_expiration_period_set,
      override_compliance_expiration_enddate:
        candidate?.override_compliance_expiration_enddate,
      is_auto_booked_on_apply: candidate?.is_auto_booked_on_apply,
    };
    arr.push(obj);
  });
  return arr;
};

export const formatAppliedCandidates = (candidates) => {
  let arr = [];
  candidates.forEach((candidate) => {
    let obj = {
      candidate_id: candidate.candidate_id,
      route_id: candidate.candidate_id
        ? apiEncrypt(candidate.candidate_id)
        : null,
      route_contract_id: apiEncrypt(candidate.contract_id),
      contract_id: candidate.contract_id,
      contract_start_date: candidate.contract_start_date,
      contract_end_date: candidate.contract_end_date,
      contract_start_time: candidate.contract_start_time,
      contract_end_time: candidate.contract_end_time,
      applicant_id: candidate.applicant_id,
      candidate_name: candidate.candidate_name,
      role_name: candidate.role_name,
      profile_image: candidate.profile_image,
      profile_percent: candidate.profile_percent,
      license_number: candidate.license_number,
      total_days_of_contract: candidate.total_days_of_contract,
      contract_ref_no: candidate.contract_ref_no,
      is_day_rate: candidate.is_day_rate,
      is_bank_candidate: candidate.is_bank_candidate,
      is_auto_booked_on_apply: candidate?.is_auto_booked_on_apply,
      contract_status: candidate.contract_status,
      apply_date: candidate.apply_date,
      is_canceled: candidate.is_canceled,
      miles: candidate.miles,
      candidate_sortlisted: parseInt(candidate.candidate_sortlisted),
      candidate_unsuitable: parseInt(candidate.candidate_unsuitable),
      rate: candidate.rate,
      is_negotiate: candidate.is_negotiate,
      isExpanded: false,
      contract_created_at: candidate.contract_created_at,
      is_bank_contract: parseInt(candidate.is_bank_contract),
      is_for_appLocum_candidates: parseInt(
        candidate.is_for_appLocum_candidates,
      ),
      bank_contract_publish_date: candidate.bank_contract_publish_date,
      mobile_phone_number: isPremiumUser()
        ? candidate.mobile_phone_number
        : null,
      candidate_email: isPremiumUser() ? candidate.candidate_email : null,
      contract_tag: candidate?.contract_tag,
      is_substitute_contract: candidate?.is_substitute_contract,
      proposed_candidate_name: candidate?.proposed_candidate_name,
      proposed_contract_id: candidate?.proposed_contract_id,
      proposed_contract_ref: candidate?.proposed_contract_ref,
      cover_request_awarded_reward:
        candidate?.cover_request_awarded_reward || 0,
    };
    arr.push(obj);
  });

  return arr;
};

export const formatCandidateDetails = (candidate) => {
  let obj = {
    // candidate_id: apiEncrypt(candidate.candidate_id),
    candidate_name: candidate.candidate_name,
    reference_no: candidate.reference_no,
    address: candidate.address,
    license_number: candidate.license_number,
    profile_percent: candidate.profile_percent,
    profile_image: candidate.profile_image,
    miles: candidate.miles,
    candidate_postcode: candidate.candidate_postcode,
    candidate_gender: candidate.candidate_gender,
    role_name: candidate.candidate_type_name,
    candidate_sortlisted: parseInt(candidate.candidate_sortlisted),
    candidate_unsuitable: parseInt(candidate.candidate_unsuitable),
    nmc_gmc_conditions: parseInt(candidate.has_nmc_gmc_conditions),
    dbs_conditions: parseInt(candidate.has_dbs_conditions),
    visa_restrictions: parseInt(candidate.has_visa_restrictions),
    shift_completed: candidate.shift_completed,
    smart_card_number: candidate.smart_card_number,
    work_email: candidate.work_email,
    mobile_phone_number: isPremiumUser() ? candidate.mobile_phone_number : null,
    candidate_email: isPremiumUser() ? candidate.candidate_email : null,
    is_bank_candidate: candidate.is_bank_candidate,
    invitation_ids: candidate?.invitation_id,
    is_client_override_compliance_period_set:
      candidate?.is_client_override_compliance_period_set,
    is_override_compliance_expiration_period_set:
      candidate?.is_override_compliance_expiration_period_set,
    override_compliance_expiration_enddate:
      candidate?.override_compliance_expiration_enddate,
    override_compliance_expiration_period_duration:
      candidate?.override_compliance_expiration_period_duration,
    override_compliance_expiration_period_type:
      candidate?.override_compliance_expiration_period_type,
    is_auto_booked_on_apply: candidate?.is_auto_booked_on_apply || "",
    is_past_booking: candidate?.is_past_booking,
  };
  return obj;
};

export const formatCandidateCalendarShifts = (shifts) => {
  let obj = {};
  // shifts.forEach((shift) => {
  //   let obj = {
  //     ...shift,
  //     contract_id: apiEncrypt(shift.contract_id),
  //   };
  //   arr.push(obj);
  // });
  Object.keys(shifts).forEach((date) => {
    let shiftArr = shifts[date];
    let arr = [];
    shiftArr.forEach((shift) => {
      let obj = {
        ...shift,
        contract_id: apiEncrypt(shift.contract_id),
      };
      arr.push(obj);
    });
    obj[date] = arr;
  });
  return obj;
};

export const formatBookedWorkedCandidates = (candidates, from) => {
  let arr = [];
  candidates.forEach((candidate) => {
    let obj = {
      candidate_id: candidate.candidate_id,
      route_id: apiEncrypt(candidate.candidate_id),
      contract_ref_no: candidate.contract_ref_no,
      contract_start_time: candidate.contract_start_time,
      contract_end_time: candidate.contract_end_time,
      break_time: candidate.break_time,
      admin_time: candidate.admin_time,
      no_of_visit: candidate.no_of_visit,
      contract_duration: candidate.contract_duration,
      candidate_name: candidate.candidate_name,
      license_number: candidate.license_number,
      role_name: candidate.role,
      profile_image: candidate.profile_image,
      profile_percent: candidate.profile_percent,
      miles: candidate.miles,
      candidate_sortlisted: parseInt(candidate.candidate_sortlisted),
      candidate_unsuitable: parseInt(candidate.candidate_unsuitable),
      rate: candidate.rate,
      is_negotiate: candidate.is_negotiate,
      candidate_email: isPremiumUser() ? candidate.candidate_email : null,
      mobile_phone_number: isPremiumUser()
        ? candidate.mobile_phone_number
        : null,
      is_past_booking: candidate?.is_past_booking,
      is_auto_booked_on_apply: candidate?.is_auto_booked_on_apply,
      license_number: candidate?.license_number || "",
      is_time_started: candidate?.is_time_started || 0,
      running_late_status: candidate?.running_late_status || 0,
      is_ongoing: candidate?.is_ongoing || 0,
      running_late_reason: candidate?.running_late_reason || "",
      logged_in_time: candidate?.logged_in_time || "",
      is_substitute_contract: candidate?.is_substitute_contract || 0,
    };
    if (from == "booked") {
      const { booked_by_name, booked_at, booked_from } = candidate;
      obj = {
        ...obj,
        booked_by_name,
        booked_at,
        booked_from,
      };
    }
    let view = candidate.view;
    if (view == "shifts") {
      obj = {
        ...obj,
        route_contract_id: apiEncrypt(candidate.contract_parent_id),
        contract_id: candidate.contract_id,
        timesheet_id: candidate.timesheet_id,
        timesheet_status: candidate.timesheet_status,
        shift_date: candidate.shift_date,
        applicant_id: candidate.applicant_id,
        is_day_rate: candidate.is_day_rate,
        contract_status: candidate.contract_status,
        apply_date: candidate.apply_date,
        client_pay_arr: candidate.client_pay_arr,
        is_past_booking: candidate?.is_past_booking || 0,
        license_number: candidate?.license_number || "",
        is_substitute_contract: candidate?.is_substitute_contract,
        cover_request_awarded_penalty:
          candidate?.cover_request_awarded_penalty || 0,
        cover_request_awarded_reward:
          candidate?.cover_request_awarded_reward || 0,
      };
      if (from == "worked") {
        let timesheetStatus = candidate.timesheet_status;
        if (
          timesheetStatus == "Authorized" ||
          timesheetStatus == "Authorised"
        ) {
          const { authorised_by_name, authorised_at, authorised_from } =
            candidate;
          obj = {
            ...obj,
            authorised_by_name,
            authorised_at,
            authorised_from,
          };
        } else if (timesheetStatus == "Rejected") {
          const { rejected_by_name, rejected_at, rejected_from } = candidate;
          obj = {
            ...obj,
            rejected_by_name,
            rejected_at,
            rejected_from,
          };
        } else if (timesheetStatus == "Terminated") {
          const {
            terminated_by_name,
            terminated_at,
            terminated_from,
            terminated_by_type,
          } = candidate;
          obj = {
            ...obj,
            terminated_by_name,
            terminated_at,
            terminated_from,
            terminated_by_type,
          };
        }
      }
    } else {
      let bookedDays = parseInt(candidate.days_booked);
      let workedDays = parseInt(candidate.days_worked);
      obj = {
        ...obj,
        route_contract_id: apiEncrypt(candidate.contract_id),
        contract_id: candidate.contract_id,
        contract_start_date: candidate.contract_start_date,
        contract_end_date: candidate.contract_end_date,
        days_booked: bookedDays,
        days_worked: workedDays,
        days_total: bookedDays + workedDays,
      };
    }
    arr.push(obj);
  });
  return arr;
};

export const formatExpandedShifts = (shifts, page) => {
  let arr = [];
  shifts.forEach((shift) => {
    let obj = {
      shift_id: shift.id,
      contract_date: shift.contract_date,
      start_time: shift.contract_start_time,
      end_time: shift.contract_end_time,
      break_time: shift.break_time,
      admin_time: shift.admin_time,
      no_of_visit: shift.no_of_visit,
      shift_rate: shift.rate,
      client_pay_arr: shift.client_pay_arr,
      cover_request_awarded_reward: shift.cover_request_awarded_reward || 0,
    };
    if (page == "worked") {
      obj.timesheet_status = shift.timesheet_status;
    }
    arr.push(obj);
  });
  return arr;
};

export const formatUnfilledContracts = (contracts) => {
  let arr = [];

  contracts.forEach((contract) => {
    let obj = {
      contract_id: contract.contract_id,
      route_contract_id: apiEncrypt(contract.contract_id),
      contract_ref_no: contract.contract_ref_no,
      contract_start_date: contract.contract_start_date,
      contract_end_date: contract.contract_end_date,
      contract_start_time: contract.contract_start_time,
      contract_end_time: contract.contract_end_time,
      un_paid_break_hour: contract.un_paid_break_hour,
      contract_admin_time: contract.contract_admin_time,
      contract_no_of_visit: contract.contract_no_of_visit,
      role_name: contract.role,
      total_days_of_contract: contract.total_days_of_contract,
      rate: contract.rate,
      is_bank_contract: parseInt(contract.is_bank_contract),
      is_for_appLocum_candidates: parseInt(contract.is_for_appLocum_candidates),
      bank_contract_publish_date: contract.bank_contract_publish_date,
      actioned_by: contract.actioned_by,
      actioned_at: contract.actioned_at,
      actioned_from: contract.actioned_from,
      contract_tag: contract.contract_tag,
      is_substitute_contract: contract.is_substitute_contract,
      proposed_candidate_name: contract.proposed_candidate_name,
      proposed_contract_id: contract.proposed_contract_id,
      proposed_contract_ref: contract.proposed_contract_ref,
      cover_request_awarded_reward: contract?.cover_request_awarded_reward || 0,
      session_type_id: contract.session_type_id,
    };
    arr.push(obj);
  });
  return arr;
};

export const formatCandidateForProposeContract = (candidates) => {
  let arr = [];
  candidates.forEach((candidate) => {
    let obj = {
      candidate_invitation_id: candidate.candidate_invitation_id,
      candidate_name: candidate.candidate_name,
      candidate_id: candidate.candidate_id,
      route_id:
        candidate.candidate_id != "-"
          ? apiEncrypt(candidate.candidate_id)
          : "-",
      candidate_email: isPremiumUser() ? candidate.candidate_email : null,
      candidate_ref_no: candidate.candidate_ref_no,
      profile_image: candidate.profile_image,
      date_invited: candidate.date_invited,
      is_registered: parseInt(candidate.is_registered),
      profile_percent: candidate.profile_percent,
      candidate_role_type: candidate.candidate_role_type,
      license_number: candidate.license_number,
      date_registered: candidate.date_registered,
      role_name: candidate.candidate_type_name,
      mobile_phone_number: isPremiumUser()
        ? candidate.mobile_phone_number
        : null,
      candidate_address: candidate.candidate_address,
      candidate_sortlisted: parseInt(candidate.candidate_sortlisted),
      candidate_unsuitable: parseInt(candidate.candidate_unsuitable),
      candidate_total_worked: parseInt(candidate.candidate_total_worked),
      miles: parseFloat(candidate.miles),
      is_send: parseInt(candidate.is_send),
      actioned_by: candidate.actioned_by,
      actioned_at: candidate.actioned_at,
    };

    arr.push(obj);
  });
  return arr;
};

export const formatChatUsersList = (users) => {
  let arr = [];
  users.forEach((user) => {
    let obj = {
      id: parseInt(user.id),
      route_id: apiEncrypt(user.id),
      ref_no: user.ref_no,
      can_name: user.can_name,
      can_role: user.can_role || "",
      email_id: user.email_id,
      last_message: user.last_message,
      last_chatted_date: user.last_chatted_date,
      unread_count: parseInt(user.unread_count),
      user_type: user.user_type,
      sender_name: user.sender_name,
      profile_found: parseInt(user.profile_found),
      profile_title: user.profile_title,
      last_active: user.last_active,
      chat: user.chat,
      is_typing: false,
      typingCount: 0,
      for_template: {
        candidate_ref_no: user.ref_no,
        candidate_full_name: user.can_name,
        candidate_name: user.can_name,
        candidate_email: user.email_id,
        candidate_title: user?.candidate_title || "candidate_title",
        candidate_firstname: user.candidate_firstname || "candidate_firstname",
        candidate_lastname: user.candidate_lastname || "candidate_lastname",
      },
      chat_type: user.chat_type || "",
    };
    arr.push(obj);
  });
  return arr;
};

export const formatChatMessages = (msgs, details) => {
  let candidateDetails = {};
  let arr = [];
  let for_template = {};
  if (!_.isEmpty(details)) {
    candidateDetails = {
      id: parseInt(details.id),
      ref_no: details.ref_no,
      route_id: apiEncrypt(details.id),
      can_name: details.can_name,
      can_role: details?.can_role || "",
      email_id: details.email_id,
      unread_count: parseInt(details.unread_count),
      user_type: details.user_type,
      profile_title: details.profile_title,
      profile_found: parseInt(details.profile_found),
      last_active: details.last_active,
      chat_type: details?.chat_type || "",
      is_typing: false,
      typingCount: 0,
      loginFrom: details.loginFrom || "",
      is_past_booking: details?.is_past_booking,
    };
    for_template = {
      candidate_ref_no: details.ref_no,
      candidate_full_name: details.can_name || "Candidate name",
      candidate_name: details.can_name || "Candidate name",
      // candidate_firstname: details.can_name.split(" ")[0],
      candidate_email: details.email_id,
      candidate_title: details?.candidate_title || "candidate_title",
      candidate_firstname:
        details?.candidate_firstname || "candidate_firstname",
      candidate_lastname: details?.candidate_lastname || "candidate_lastname",
    };
  }

  msgs.forEach((msg) => {
    let obj = {
      id: parseInt(msg.id),
      sender_id: parseInt(msg.sender_id),
      receiver_id: parseInt(msg.receiver_id),
      message: msg.message,
      template_msg: msg.template_msg,
      message_type: msg.message_type,
      original_filename: msg.original_filename,
      filename: msg.filename,
      status: msg.status,
      is_deleted: msg.is_deleted,
      send_from: msg.send_from,
      send_to: msg.send_to,
      created_at: msg.created_at,
      updated_at: msg.updated_at,
      file_found: msg.file_found,
      initiate_status: msg.initiate_status,
      conversation_type: msg?.conversation_type || "single",
    };
    arr.push(obj);
  });

  return { candidateDetails, data: arr, for_template };
};

export const formatInvoicesList = (invoices) => {
  let arr = [];
  invoices.forEach((invoice) => {
    let obj = {
      invoice_id: invoice.invoice_id,
      invoice_ref_no: invoice.invoice_ref_no,
      route_id: apiEncrypt(invoice.candidate_id),
      route_contract_id: apiEncrypt(invoice.contract_id),
      contract_id: invoice.contract_id,
      contract_ref_no: invoice.contract_ref_no,
      candidate_id: invoice.candidate_id,
      candidate_name: invoice.candidate_name,
      role_name: invoice.candidate_type_name,
      profile_image: invoice.profile_image,
      invoice_date: invoice.invoice_date,
      invoice_due_date: invoice.invoice_due_date,
      invoice_paid: parseInt(invoice.invoice_paid),
      invoice_paid_date: invoice.invoice_paid_date,
      total_hours: invoice.total_hours,
      job_title: invoice.job_title,
      total_amount: invoice.total_amount,
      candidate_sortlisted: parseInt(invoice.candidate_sortlisted),
      candidate_unsuitable: parseInt(invoice.candidate_unsuitable),
      is_past_booking: invoice?.is_past_booking,
      invoice_status: invoice?.invoice_status,
      is_auto_booked_on_apply: invoice?.is_auto_booked_on_apply,
    };

    arr.push(obj);
  });

  return arr;
};

export const formatAuthorisedTimesheets = (timesheets) => {
  let arr = [];

  timesheets.forEach((timesheet) => {
    let obj = {
      timesheet_id: timesheet.timesheet_id,
      timesheet_status: timesheet.timesheet_status,
      route_id: apiEncrypt(timesheet.candidate_id),
      route_contract_id: apiEncrypt(timesheet.contract_parent_id),
      contract_id: timesheet.contract_id,
      contract_ref_no: timesheet.contract_ref_no,
      shift_date: timesheet.shift_date,
      candidate_name: timesheet.candidate_name,
      profile_image: timesheet.profile_image,
      start_time: timesheet.start_time,
      end_time: timesheet.end_time,
      break_time: timesheet.break_time,
      admin_time: timesheet.admin_time,
      no_of_visit: timesheet.no_of_visit,
      units: timesheet.units,
      miles: timesheet.miles,
      role_name: timesheet.candidate_type_name,
      profile_percent: timesheet.profile_percent,
      license_number: timesheet.license_number,
      candidate_sortlisted: parseInt(timesheet.candidate_sortlisted),
      candidate_unsuitable: parseInt(timesheet.candidate_unsuitable),
      shift_rate: timesheet.shift_rate,
      client_pay_arr: timesheet.client_pay_arr,
      actioned_by: timesheet.actioned_by,
      actioned_at: timesheet.actioned_at,
      actioned_from: timesheet.actioned_from,
      mobile_phone_number: isPremiumUser()
        ? timesheet.mobile_phone_number
        : null,
      candidate_email: isPremiumUser() ? timesheet.candidate_email : null,
      is_auto_booked_on_apply: timesheet.is_auto_booked_on_apply,
      cover_request_awarded_penalty:
        timesheet?.cover_request_awarded_penalty || 0,
      cover_request_awarded_reward:
        timesheet?.cover_request_awarded_reward || 0,
    };
    arr.push(obj);
  });

  return arr;
};

export const formatTimesheets = (timesheets, isTerminated = 0) => {
  let arr = [];
  let isPremium = isPremiumUser();
  timesheets.forEach((timesheet) => {
    let obj = {
      ...timesheet,
      route_id: apiEncrypt(timesheet.candidate_id),
      route_contract_id: apiEncrypt(timesheet.contract_parent_id),
      is_found: parseInt(timesheet.is_found),
      has_edit_required: parseInt(timesheet.has_edit_required),
      role_name: timesheet.candidate_type_name,
      candidate_sortlisted: parseInt(timesheet.candidate_sortlisted),
      candidate_unsuitable: parseInt(timesheet.candidate_unsuitable),
      mobile_phone_number: isPremium ? timesheet.mobile_phone_number : null,
      candidate_email: isPremium ? timesheet.candidate_email : null,
      upcoming_reward_amount_for_cover_request:
        timesheet?.upcoming_reward_amount_for_cover_request || 0,
      upcoming_penalty_amount_for_cover_request:
        timesheet?.upcoming_penalty_amount_for_cover_request || 0,
      cover_by_candidate_id: apiEncrypt(timesheet.cover_by_candidate_id),
      cover_by_contract_id: apiEncrypt(timesheet.cover_by_contract_id),
    };

    if (isTerminated == 1) {
      obj.timesheet_id = timesheet.timesheet_id;
      obj.timesheet_status = timesheet.timesheet_status;
      obj.reject_or_terminate_reason = timesheet.reject_or_terminate_reason;
      obj.rejected_or_terminated_by = timesheet.rejected_or_terminated_by;
      obj.rejected_or_terminated_at = timesheet.rejected_or_terminated_at;
      obj.rejected_or_terminated_user_type =
        timesheet.rejected_or_terminated_user_type;
      obj.rejected_or_terminated_user_dept =
        timesheet.rejected_or_terminated_user_dept;
      obj.rejected_or_terminated_user_from =
        timesheet.rejected_or_terminated_user_from;
      obj.terminated_candidate_name = timesheet.terminated_candidate_name;
    }

    arr.push(obj);
  });
  return arr;
};

export const formatAdjustAmendmentData = (data) => {
  let obj = {
    startTime: data.startTime,
    endTime: data.endTime,
    adminTime: data.adminTime,
    breakTime: data.breakTime,
    noOfVisits: data.noOfVisits,
    contractUnits: data.contract_units,
    fromRates: data.from_rates,
    isDayRate: data.is_day_rate,
    contractRateDetails: data.contractRateDetails,
    contractMultipleRatesArray: data.contract_multiple_rates_array,
    contractMultipleCustomRate: data.contract_multiple_custom_rate,
    signOffId: data.sign_off_obj.id,
    contractId: data.model.id,
    contractChildId: data.model.session_type_id,
    contractParentId: data.model.session_parent_id,
    contractClientId: data.model.contract_client_id,
    contractClientRateId: data.contractRateDetails.client_rate_id,
    contractUpdatedRate: data.contractRateDetails.updated_rate,
  };

  return obj;
};

export const formatRolesList = (roles, currentRoleName = "") => {
  let arr = [];
  roles.forEach((role) => {
    let obj = {
      role_id: apiEncrypt(role.id),
      decr_role_id: role.id,
      role_name: role.role_name,
      role_description: role.role_description,
      agency_id: role.agency_id,
      is_admin: parseInt(role.is_admin) || 0,
      is_logged_user_role:
        currentRoleName && role.role_name === currentRoleName,
      permission_count: role.permission_count || 0,
      status: "1",
      created_at: role.created_at,
      updated_at: role.updated_at || "-",
    };

    arr.push(obj);
  });

  return arr;
};

export const formatFetchUserListing = (users) => {
  let arr = [];

  users.forEach((user) => {
    let obj = {
      client_user_id: apiEncrypt(user.client_user_id),
      user_id: user.client_user_id,
      client_user_name: user.client_user_name,
      profile_image: user.profile_image || "",
      role: user.role,
      role_id: user.role_id,
      user_email: user.user_email,
      phone_number: user.phone_number,
      direct_dial: user.direct_dial || "",
      is_primary: parseInt(user.is_primary),
      status: parseInt(user.status),
      created_at: user.created_at,
    };
    arr.push(obj);
  });
  return arr;
};
